import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import axios from 'axios';
import * as uuid from 'uuid';
import MapUtils from "qwc2/utils/MapUtils";
import clientAuth from "../ClientAuth";
import LocaleUtils from "qwc2/utils/LocaleUtils";
import ConfigUtils from "qwc2/utils/ConfigUtils";
import MapStateUtils from "../utils/MapStateUtils";
import MapStateService from "../utils/MapStateService";
import "../style/MapStateMgr.css";
import {changeZoomLevel, panTo} from "qwc2/actions/map";
import {changeLayerProperty} from "qwc2/actions/layers";

class MapStateMgr extends React.Component {
    static propTypes = {
        changeLayerProperty: PropTypes.func,
        changeZoomLevel: PropTypes.func,
        layers: PropTypes.array,
        map: PropTypes.object,
        mapScale: PropTypes.number,
        panTo: PropTypes.func
    }
    static defaultProps = {
        levelFilter: 0,
        levelFilterMin: 0,
        levelFilterMax: 3
    }

    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            newName: '',
            configlist: []
        };
    }

    getUrl() {
        return ConfigUtils.getConfigProp("mapstateServiceUrl");
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        const self = this;
        axios.get(this.getUrl(), clientAuth.headers())
            .catch(function () {
                // api sends a 404 if there is no list
                self.setState({configlist: []});
            })
            .then(res => {
                if (res && res.data) {
                    self.setState({configlist: res.data.mapstates});
                } else {
                    self.setState({configlist: []});
                }
            });
    }

    componentDidUpdate() {
    }

    save() {
        const self = this;
        const data = {
            id: uuid.v4(),
            name: this.state.newName,
            ...MapStateService.buildState(this.props.map, this.props.layers)
        };
        MapStateService.create(data)
            .catch(function (error) {
                console.log('Api error', error);
            })
            .then(() => {
                self.loadData();
            });
    }

    apply(item) {
        MapStateUtils.apply(item, this.props);
    }

    remove(item) {
        const self = this;
        axios.delete(this.getUrl() + item.id, clientAuth.headers())
            .catch(function (error) {
                console.log('Api error', error);
            })
            .then(res => {
                self.loadData();
            });
    }

    setDefault(item, value) {
        const self = this;
        axios.put(this.getUrl() + item.id, {isDefault: value}, clientAuth.headers())
            .catch(function (error) {
                console.log('Api error', error);
            })
            .then(res => {
                self.loadData();
            });
    }

    renderItem(item) {
        return (
            <div key={item.id}>
                <span className="name layertree-item-title" onClick={() => this.apply(item)}>{item.name}</span>
                <span className="layertree-item-spacer"></span>
                {item.isDefault == 1 &&
                    <span className="icon icon-checked layertree-item-remove" onClick={() => this.setDefault(item, 0)}></span>
                }
                {item.isDefault == 0 &&
                    <span className="icon icon-unchecked layertree-item-remove" onClick={() => this.setDefault(item, 1)}></span>
                }
                <span className="icon icon-trash layertree-item-remove" onClick={() => this.remove(item)}></span>
            </div>
        );
    }

    renderList() {
        if (!this.state.configlist || this.state.configlist.length == 0) {
            return null;
        }
        return (
            <div>
                {this.state.collapsed &&
                    <div className="mapstate-mgr-toggle" onClick={() => this.setState({collapsed: false})}>
                        <span className="icon icon-tree_plus icon_clickable"></span>
                        <span>{LocaleUtils.tr('mapstatemgr.myconfigs')}</span>
                    </div>
                }
                {!this.state.collapsed &&
                    <div>
                        <div className="mapstate-mgr-toggle" onClick={() => this.setState({collapsed: true})}>
                            <span className="icon icon-tree_minus icon_clickable"></span>
                            <span>{LocaleUtils.tr('mapstatemgr.myconfigs')}</span>
                        </div>
                        <div className="mapstate-mgr-list">
                            {this.state.configlist.map(ms => this.renderItem(ms))}
                        </div>
                    </div>
                }
            </div>
        );
    }

    render() {

        return (
            <div className="layertree-option" style={{height: 'auto'}}>
                <div className="mapstate-mgr">
                    {this.renderList()}
                    <div className="mapstate-mgr-form">
                        <input onChange={ev => this.setState({newName: ev.target.value})}
                               placeholder={LocaleUtils.tr('mapstatemgr.newname')} type="text"
                               value={this.state.newName}/>
                        <button className="button" onClick={ev => this.save()}><i className="icon icon-save"></i>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

const selector = (state) => ({
    layers: state.layers.flat,
    map: state.map,
    mapScale: MapUtils.computeForZoom(state.map.scales, state.map.zoom)
});

export default connect(selector, {
    changeLayerProperty: changeLayerProperty,
    changeZoomLevel: changeZoomLevel,
    panTo: panTo
})(MapStateMgr);
